// Placeholder be overridden by `make pull_translations`
export default [];
